import type { CompanyResponse } from '@saas/api-client';
import { buildTenantUrl } from '@/utils/app-domain';

// Where a session lands when it enters a workspace; every app shell in `App.tsx` agrees on it.
export const COMPANY_ENTRY_PATH = '/dashboard';

export const buildCompanyEntryUrl = (company: Pick<CompanyResponse, 'subDomain'>): string =>
	buildTenantUrl(company.subDomain, COMPANY_ENTRY_PATH);
